import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { NodeGraphView } from "../NodeGraphView";
import { NodeGraphComponent } from "./NodeGraphComponent";
import { Vector2 } from "three";
import { DragData } from "../../../library-js/dom-ui/basics/DragData";
import { Events, OnDrag, OnMouseEnter, OnMouseLeave } from "../../../library-js/dom-tools/EventListeners";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { TemplateDefaults } from "../../TemplateDefaults";
import { DOMHitTest } from "../../../library-js/dom-tools/DOMHitTest";
import { NodeGraphReference } from "./NodeGraphReference";
import { NodeGraph } from "./NodeGraph";
import { HSLColor } from "../../../library-js/colors/HSLColor";
import { HTMLColor } from "../../../library-js/colors/HTMLColor";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";

export class NodeGraphNode extends NodeGraphReference
{
  static type             = new ElementType<HTMLElement>( "node-node" );

  static header           = new ElementType<HTMLElement>( "node-header" );
  static dragArea         = new ElementType<HTMLElement>( "node-drag-area" );
  static content          = new ElementType<HTMLElement>( "node-content" );

  

  _htmlElement:HTMLElement;
  _header:HTMLElement;
  _color:HTMLColor;
  _id:string;

  _components:NodeGraphComponent[] = [];

  updateComponentConnectorPositions()
  {
    this._components.forEach( c => c.updateConnectorPositions() );
  }

  setSelectionState( selected:boolean )
  {
    ClassFlag.selected.setAs( this._htmlElement, selected );

    if ( selected )
    {
      HTMLEditor.setLast( this._htmlElement );
    }
  }

  setColor( color:HTMLColor )
  {
    let hsl = color.toHSL();
    let hsl2 = color.toHSL();
    hsl.s = 10;
    hsl.l = 30;

    this._color = hsl;
    

    let warm   = hsl.clone().shiftWarmerHue( 30 ).saturate( -30 ).lighten( 2 ).toHSL().clamp();
    let center = hsl.clone().lighten( -10 ).toHSL().clamp()
    let dark   = hsl.clone().shiftWarmerHue( -30 ).saturate( 5 ).lighten( -20 ).toHSL().clamp();

    let fade = 0.97;

    warm.a = fade;    
    center.a = fade; 
    dark.a = fade; 

    
    let background = `repeating-linear-gradient(
      -45deg,
      hsla(0,0%,100%,0.02) 0px,
      hsla(0,0%,100%,0.01) 20px,
      hsla(0,0%,0%,0.02) 20px,
      hsla(0,0%,0%,0.01) 40px )` 
    ;


    background += `, linear-gradient(180deg, ${warm.toString()} 0%, ${center.toString()} 50%, ${dark.toString()} 100%)`;

    let noisePath = "Marble/Marble_02-512x512";
    background += `, url("../../_graphics/noise/${noisePath}.png")`;


    this._htmlElement.style.background = background;
    this._htmlElement.style.backgroundPosition = `${Math.random()*1000}% ${Math.random()*1000}%`;

    console.log( "background:", background );

    hsl2.s = 100;
    hsl2.l = 70;

    
    //hsl2.setPhysicalLightness( 100, 0.5 );

    let hsl3 = hsl2.clone();
    hsl3.a = 0.4;
    let filter = `drop-shadow(0em 0em 0.1em ${hsl2}) drop-shadow(0em 0em 2em ${hsl3})`;

    let header = NodeGraphNode.header.query( this._htmlElement );
    header.style.filter = filter;
    header.style.color = hsl + "";

  }
  
  move( offset:Vector2 )
  {
    let parent = this._htmlElement;
    let parentPosition = new Vector2();
    parentPosition.x = parseFloat( parent.style.left.replace( /px/, "" ) );
    parentPosition.y = parseFloat( parent.style.top.replace( /px/, "" ) );

    parentPosition.add( offset );

    parent.style.left = parentPosition.x + "px";
    parent.style.top  = parentPosition.y + "px";

  }

  intizialize( ng:NodeGraph, e:Element )
  {
    this._htmlElement = e as HTMLElement;
    this.setID( ng );

    NodeGraphReference.attribute.to( this._htmlElement, this._id );

    this._color = new HSLColor( Math.random() * 360, 100, 50 );

    let nodeElement = this._htmlElement;
    let dragArea = NodeGraphNode.dragArea.query( this._htmlElement ) as HTMLElement;
    let dragData:DragData<Vector2> = null;
    let parent = this._htmlElement as HTMLElement;

    let componentContents = NodeGraphComponent.componentContent.queryAll( nodeElement ) as HTMLElement[];
    let components = NodeGraphComponent.type.queryAll( nodeElement ) as HTMLElement[];

    for ( let i = 0; i < components.length; i++ )
    { 
      let nodeGraphComponent = new NodeGraphComponent();
      nodeGraphComponent.initilize( this, components[ i ] );

      this._components.push( nodeGraphComponent );

      console.log( "Adding component:", nodeGraphComponent );
    }

    let header     = NodeGraphNode.header.query( nodeElement ) as HTMLElement; 

    this.setColor( new HSLColor( Math.random() * 360, 50, 30 ) ); 
    let dragElements = [ header, dragArea ].concat( componentContents );
    

    dragElements.forEach( d => 
    {
      OnMouseEnter.add( d, 
        ( me )=>
        {
          ClassFlag.hovered.set( parent );
        }
      );

      OnMouseLeave.add( d, 
        ( me )=>
        {
          ClassFlag.hovered.removeFrom( parent );
        }
      );

      /*OnDrag.add( d, 
        ( e ) =>
        {
          //console.log( e );
          
          if ( Events.isStart( e ) )
          {
            let parentPosition = new Vector2();
            parentPosition.x = parseFloat( parent.style.left.replace( /px/, "" ) );
            parentPosition.y = parseFloat( parent.style.top.replace( /px/, "" ) );

            dragData = DragData.create( e, parentPosition );

            TemplateDefaults.noSelection.set( parent );
            ClassFlag.dragging.set( parent );
          }

          if ( Events.isEnd( e ) )
          {
            TemplateDefaults.noSelection.removeFrom( parent );
            ClassFlag.dragging.removeFrom( parent );
            
          }

          let position = DOMHitTest.getPointerPosition( e );
          let offset = dragData.position.clone().sub( position );

          let nextParentPosition = dragData.value.clone().sub( offset );

          parent.style.left = nextParentPosition.x + "px";
          parent.style.top  = nextParentPosition.y + "px";

          this._nodeGraph._ui.updateEdges();
        } 
      )*/
    });
  }



}